module.exports = __webpack_public_path__ + "static/media/santander-azul.09d5901c.webp";